import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { actions, service } from "./model";
import Dashboard from "./pages/Dashboard";
import TokenRedirect from "./pages/TokenRedirect";

function ProtectedRoute({ children }) {
  const user = useSelector((state) => state.user?.redux_object || null);
  if (user && user.accessToken) return children;
  window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
  return null;
}

function App() {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user?.redux_object || null);

  return (
    <>
      <Routes>
        <Route path="/token-login" element={<TokenRedirect />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<h1>404: Pagina non trovata</h1>} />
      </Routes>
    </>
  );
}

export default App;
